var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inj-home"},[_c('div',{staticClass:"inj-home__map-row"},[_c('HomeMap'),_c('HomeMapSideColumn')],1),_c('FeaturedArticle',{attrs:{"slug":"full-of-anxiety-and-some-fear"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }